import { Theme } from '../@types/AppProps';

const WAYKE_VALUATION_THEME = 'wayke-valuation-theme';

export const createTheme = (theme?: Theme) => {
  if (!theme) return;
  const exist = document.getElementById(WAYKE_VALUATION_THEME);
  const style = exist || document.createElement('style');
  style.id = WAYKE_VALUATION_THEME;

  style.innerHTML = `
    ${
      theme.buttonBorderRadius
        ? `
        /* Button Border Radius */
        .waykevaluation-root .waykevaluation-button {
          border-radius: ${theme.buttonBorderRadius};
        }
        `
        : ''
    }

    ${
      theme.primaryBackground || theme.primaryForeground
        ? `
    /* Button Primary (action) */
    .waykevaluation-root .waykevaluation-button.waykevaluation-button--action {
      ${theme.primaryBackground ? `background-color: ${theme.primaryBackground};` : ''}
      ${theme.primaryForeground ? `color: ${theme.primaryForeground};` : ''}
    }

    /* Input Selection Color */
    .waykevaluation-root .waykevaluation-input-selection {
      ${
        theme.primaryBackground ? `--waykevaluation-checked-color: ${theme.primaryBackground};` : ''
      }
      ${
        theme.primaryForeground
          ? `--waykevaluation-checked-color-alt: ${theme.primaryForeground};`
          : ''
      }
    }
    `
        : ''
    }

    ${
      theme.secondaryBackground || theme.secondaryForeground
        ? `
    /* Button Secondary (action-alt) */
    .waykevaluation-root .waykevaluation-button.waykevaluation-button--action-alt {
      ${theme.secondaryBackground ? `background-color: ${theme.secondaryBackground};` : ''}
      ${theme.secondaryForeground ? `color: ${theme.secondaryForeground};` : ''}
    }
    `
        : ''
    }

    ${
      theme.floatingBackground || theme.floatingForeground
        ? `
    /* Floating Panel (init) */
    .waykevaluation-root .waykevaluation-init {
      ${theme.floatingBackground ? `background-color: ${theme.floatingBackground};` : ''}
      ${theme.floatingForeground ? `color: ${theme.floatingForeground};` : ''}
    }
    `
        : ''
    }

    ${
      theme.linkColor
        ? `
      /* Link Color */
      .waykevaluation-root .waykevaluation-link:not(.waykevaluation-link--current-color) {
        color: ${theme.linkColor};
      }
    `
        : ''
    }
  `;

  if (!exist) {
    document.head.appendChild(style);
  }
};
